/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { ServiceCategoryModelSearchResultModel } from '../../models/service-category-model-search-result-model';

export interface ServiceCategorySearchServiceCategoryAsyncPost$Params {
      body?: SearchRequestModel
}

export function serviceCategorySearchServiceCategoryAsyncPost(http: HttpClient, rootUrl: string, params?: ServiceCategorySearchServiceCategoryAsyncPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceCategoryModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, serviceCategorySearchServiceCategoryAsyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ServiceCategoryModelSearchResultModel>;
    })
  );
}

serviceCategorySearchServiceCategoryAsyncPost.PATH = '/ServiceCategory/SearchServiceCategoryAsync';
